import { useFormik } from 'formik';
import React, { useContext, useEffect, useState } from 'react';

import BtnLoad from '../../MyCustom/BtnLoad';
import Button from '../../bootstrap/Button';
import { CardBody } from '../../bootstrap/Card';
import Modal, { ModalBody, ModalHeader, ModalTitle } from '../../bootstrap/Modal';
import FormGroup from '../../bootstrap/forms/FormGroup';
import Input from '../../bootstrap/forms/Input';
import { DefaultContext } from '../../../contexts/default';
import InsumosHistoryDB from '../../../database/wrappers/insumosHistory';
import InsumosStoreDB from '../../../database/wrappers/insumosStore';
import PreAlert from '../../../helpers/utils/preAlert';
import { limit, orderBy, Timestamp, where } from 'firebase/firestore';
import Money from '../../../helpers/utils/money/money';
import { unmask } from '../../../helpers/utils/masks';

const validate = (values) => {
    const errors = {};
    if (!values.qtd) errors.qtd = 'Este campo é necessário';
    return errors;
};

const ModalEditQtd = ({ open, handleOpen, insumoSelected }) => {
    const { estabSelected, storeSelected, onShowAlert } = useContext(DefaultContext);

    const [isLoading, setIsLoading] = useState(false);
    const [insumeHistory, setHistoryInsume] = useState(null)

    useEffect(() => {
        if (!insumoSelected) return;
        new InsumosHistoryDB(estabSelected, storeSelected).getAll(
            where("insumeId", "==", insumoSelected.id),
            orderBy("created_at", "desc"),
            limit(1)
        ).then((insumeHistory) => {
            setHistoryInsume(insumeHistory[0])
            const { price, qtd } = insumeHistory[0]
            formik.setFieldValue('price', price);
            formik.setFieldValue('qtd', qtd);
            formik.setFieldValue('totalPrice', price * qtd);
        })
    }, [insumoSelected])

    const formik = useFormik({
        initialValues: {
            qtd: '',
            price: "",
            unit: '',
            totalPrice: ''
        },
        validate,
        onSubmit: async (values) => {
            if (!insumeHistory) return;
            setIsLoading(true);
            const { qtd, price } = values;

            const onSuccess = () => {
                onShowAlert(PreAlert.success('Registro cadastrado com sucesso'));
                handleOpen();
            };

            const onError = (_error) => {
                onShowAlert(PreAlert.error('Falhou ao cadastrar o registro'));
            };

            const priceUnMask = Number(price)
            try {
                const diferenca = insumoSelected.qtd - insumeHistory.qtd
                const novoValor = diferenca + qtd
                if (novoValor <= 0) {
                    onShowAlert(PreAlert.error('Valor deixará o estoque vazio'));
                    return
                }

                await new InsumosHistoryDB(estabSelected, storeSelected)
                    .update(insumeHistory.id, {
                        price: priceUnMask,
                        qtd
                    })
                await new InsumosStoreDB(estabSelected, storeSelected)
                    .update(insumoSelected.id, {
                        price: priceUnMask,
                        qtd: novoValor
                    })

                onSuccess();
            } catch (error) {
                console.error(error);
                onError(error);
            } finally {
                setIsLoading(false);
            }
        },
    });

    const handlePriceChange = (e) => {
        const unitPrice = unmask(e.target.value)
        formik.setFieldValue('price', unitPrice);
        const qtd = formik.values.qtd;
        if (unitPrice && qtd) {
            const qtdNumber = Number(qtd);
            if (!isNaN(unitPrice) && !isNaN(qtdNumber)) {
                const total = unitPrice * qtdNumber;
                formik.setFieldValue('totalPrice', total);
            }
        }
    };

    const handleTotalPriceChange = (e) => {
        const totalPrice = unmask(e.target.value)
        formik.setFieldValue('totalPrice', totalPrice);
        const qtd = formik.values.qtd;
        if (totalPrice && qtd) {
            const qtdNumber = Number(qtd);
            if (!isNaN(totalPrice) && !isNaN(qtdNumber) && qtdNumber !== 0) {
                const price = totalPrice / qtdNumber;
                formik.setFieldValue('price', price);
            }
        }
    };

    const handleQtdChange = (e) => {
        const qtd = Number(e.target.value);
        formik.setFieldValue('qtd', qtd);

        const unitPrice = Number(formik.values.price)
        const totalPrice = Number(formik.values.totalPrice)

        if (!qtd || isNaN(qtd) || qtd === 0) {
            formik.setFieldValue('qtd', '');
            return
        }
        else if (unitPrice && qtd) {
            if (!isNaN(unitPrice) && !isNaN(qtd) && qtd !== 0) {
                const total = unitPrice * qtd
                formik.setFieldValue('price', unitPrice)
                formik.setFieldValue('totalPrice', total);
            }
            return
        }
        else {
            if (!isNaN(totalPrice) && !isNaN(qtd) && qtd !== 0) {
                const unit = totalPrice / qtd
                formik.setFieldValue('price', unit)
                formik.setFieldValue('totalPrice', totalPrice);
            }
            return
        }
    };

    useEffect(() => {
        if (open) {
            formik.resetForm();
        }
    }, [open, insumoSelected]);

    return (
        <Modal
            isOpen={open}
            setIsOpen={handleOpen}
            isStaticBackdrop
            isScrollable={false}
            isCentered
            size="lg"
            isAnimation
            onSubmit={formik.handleSubmit}
        >
            <ModalHeader className="p-4 mt-2 justify-content-start" setIsOpen={handleOpen}>
                <ModalTitle>
                    {'Editar ultima entrada'}
                </ModalTitle>
            </ModalHeader>
            <ModalBody className="p-5">
                <form noValidate onSubmit={formik.handleSubmit}>
                    <div className='d-flex flex-column align-items-center col-md-12'>
                        <h3 style={{ marginTop: 20, marginBottom: 20 }}>{insumoSelected?.name}</h3>
                    </div>
                    <CardBody className="p-2">
                        <div className="row gap-3">
                            <div className="row d-flex justify-content-center">

                                <FormGroup id="unit" label={'Unidade'} className='col-md-2'>
                                    <Input
                                        disabled={true}
                                        value={insumoSelected?.unit}
                                    />
                                </FormGroup>

                                {/* Qtd */}
                                <FormGroup id="qtd" label="Quantidade" className="col-md-2 mb-4">
                                    <Input
                                        isValid={formik.isValid}
                                        isTouched={formik.touched.qtd}
                                        invalidFeedback={formik.errors.qtd}
                                        validFeedback="Assim está bom!"
                                        placeholder="1000"
                                        type='number'
                                        name="qtd"
                                        value={formik.values.qtd}
                                        onChange={handleQtdChange}
                                    />
                                </FormGroup>

                                {/* Value UN */}
                                <FormGroup
                                    id="price"
                                    label="Preço Unitario"
                                    className="col-md-3 mb-4"
                                >
                                    <Input
                                        name="price"
                                        onChange={handlePriceChange}
                                        onBlur={formik.handleBlur}
                                        value={Money.centsToMaskMoney(formik.values.price)}
                                        isValid={formik.isValid}
                                        isTouched={formik.touched.price}
                                        invalidFeedback={formik.errors.price}
                                        validFeedback='Assim está bom!'
                                        placeholder='10,00'
                                    />
                                </FormGroup>

                                {/* Value Total */}
                                <FormGroup
                                    id="totalPrice"
                                    label="Preço Total"
                                    className="col-md-3 mb-4"
                                >
                                    <Input
                                        name="totalPrice"
                                        onChange={handleTotalPriceChange}
                                        onBlur={formik.handleBlur}
                                        value={Money.centsToMaskMoney(formik.values.totalPrice)}
                                        isValid={formik.isValid}
                                        isTouched={formik.touched.totalPrice}
                                        invalidFeedback={formik.errors.totalPrice}
                                        validFeedback='Assim está bom!'
                                        placeholder='10,00'
                                    />
                                </FormGroup>
                            </div>
                        </div>
                    </CardBody>

                    <div className="row pt-4">
                        <div className="d-flex justify-content-end gap-2">
                            <Button
                                color="danger"
                                icon="cancel"
                                rounded={1}
                                onClick={handleOpen}
                                shadow="sm"
                                hoverShadow="sm"
                                size="sm"
                            >
                                Cancelar
                            </Button>

                            {isLoading ? (
                                <BtnLoad />
                            ) : (
                                <Button
                                    isDisable={!formik.isValid && !!formik.submitCount}
                                    type="submit"
                                    color="success"
                                    icon="check"
                                    rounded={1}
                                    hoverShadow="sm"
                                    shadow="sm"
                                    size="sm"
                                >
                                    Salvar
                                </Button>
                            )}
                        </div>
                    </div>
                </form>
            </ModalBody>
        </Modal >
    );
}

export default ModalEditQtd;